import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../constants/theme';

export const Logo = styled.img`
  display: block;
  margin: auto;
  margin-bottom: 45px;
`;

export const StrongSpan = styled.span`
  font-weight: 700;
  color: ${COLOR.text};
`;

export const MainSection = styled.main`
  margin: auto auto 30px;
  width: 80%;
`;

export const OrDivider = styled.p`
  margin: ${SPACING.lg} 0 ${SPACING.md};
  font-size: ${FONT_SIZE.body};
  font-weight: 600;
  text-align: center;
  color: ${COLOR.textMuted};
`;

export const AltRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const HeroImage = styled.div`
  margin: ${SPACING.xxl} auto 0;
  text-align: center;

  img {
    width: 64%;
    max-width: 280px;
  }
`;
